/**
 * Address of the private sales space. Deliberately not "admin": scanners try the obvious
 * names. It only keeps the login page out of casual reach; this file ships in the public
 * bundle, so the real protection is the admin login the API enforces on every call.
 * One path segment only, the page uses a relative <base>.
 */
export const ADMIN_PATH = 'espace-qjdrsc7f09';
